import { createContext } from 'react';
import translations from '../localization';

// Create a context with default value of our English translations
const LocalizationContext = createContext(translations);

export default LocalizationContext;